module.exports = __webpack_public_path__ + "img/wizbit.14078458.png";